import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  /**
   * Clear ERP menu cache entries from localStorage
   */
  clearERPMenuCache(): void {
    try {
      // Clear all menu cache entries
      const menuCacheKeys = [
        'cc_menu_cache_admin_menu_get',        // Main menu cache
        'cc_menu_cache_admin_menu_getMenu',    // User menu cache  
        'cc_menu_cache_admin_menu_getPageCodes', // Page codes cache
        'cc_erp_search_value'                  // Search value
      ];
  
      menuCacheKeys.forEach(key => {
        localStorage.removeItem(key);
      });
  
    } catch (error) {
      console.warn('Failed to clear menu cache:', error);
    }
  }

}
